import { render, staticRenderFns } from "./indexgraduate.vue?vue&type=template&id=fed01e4a&scoped=true"
import script from "./indexgraduate.vue?vue&type=script&lang=js"
export * from "./indexgraduate.vue?vue&type=script&lang=js"
import style0 from "./indexgraduate.vue?vue&type=style&index=0&id=fed01e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed01e4a",
  null
  
)

export default component.exports